import { bindable, bindingMode, customElement } from 'aurelia-framework';
import CommonSearchVMBase from 'Lib/Fs.SmartClient.Client/CommonSearchVMBase';
import * as uniqid from 'uniqid';

@customElement('fs-paging-2')
export class FsPaging2 {
    DataContext: CommonSearchVMBase;
    @bindable public IsDialog: boolean = false;
    Select2Id: string;

  @bindable public Paging: any[] = [{ id: 5, text: "5" }, { id: 10, text: "10" }, { id: 15, text: "15" }, { id: 20, text: "20" }, { id: 30, text: "30" }, { id: 50, text: "50" }, { id: 9999999, text: "All" }]

    bind(bindingContext: any, overrideContext: any) {
        this.DataContext = bindingContext;
        this.Select2Id = uniqid.default();
    }
}
